import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';

import { AuthSplitLayout } from 'src/layouts/auth-split';

import { SplashScreen } from 'src/components/loading-screen';

import { GuestGuard } from 'src/auth/guard';

import { AuthRedirectBehavior, AuthLogoutRedirectBehavior } from '../components';

// ----------------------------------------------------------------------

/** **************************************
 * Jwt
 *************************************** */
const Jwt = {
  SignInPage: lazy(() => import('src/pages/auth/jwt/sign-in')),
};

const authJwt = {
  path: 'jwt',
  children: [
    {
      path: 'sign-in',
      element: (
        <GuestGuard>
          <AuthSplitLayout
            slotProps={{
              section: { title: 'Hi, Welcome back' },
            }}
          >
            <Jwt.SignInPage />
          </AuthSplitLayout>
        </GuestGuard>
      ),
    },
  ],
};

// ----------------------------------------------------------------------

export const authRoutes: RouteObject[] = [
  {
    path: 'auth',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [authJwt],
  },
  {
    path: 'auth-redirect',
    element: (
      <>
        {/*
         *Intentionally contains duplicate child component, ensures
         * MSAL gets to handle the auth redirect before redirecting
         * to another app page.
         */}
        <AuthenticatedTemplate>
          <AuthRedirectBehavior />
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <AuthRedirectBehavior />
        </UnauthenticatedTemplate>
      </>
    ),
  },
  {
    path: 'auth-logout',
    element: (
      <>
        {/*
         *Intentionally contains duplicate child component, ensures
         * MSAL gets to handle the auth redirect before redirecting
         * to another app page.
         */}
        <AuthenticatedTemplate>
          <AuthLogoutRedirectBehavior />
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <AuthLogoutRedirectBehavior />
        </UnauthenticatedTemplate>
      </>
    ),
  },
];
